export enum RecurringDonation {
  RECURRING = 1,
  NON_RECURRING = 0,
}

export enum ShareType {
  STANDARD = 1,
  CUSTOM = 0,
}

export enum PaymentMethod {
  BANK = 2,
  PAYPAL = 3,
  VIPPS_KID = 4,
  BANK_UKID = 5,
  VIPPS = 6,
  AVTALEGIRO = 7,
  QUICKPACK_MOBILEPAY = 98,
  QUICKPAY_CARD = 99,
  DKBANK = 97,
}
